export default __webpack_public_path__ + "static/media/check-mark.efadc922.svg";